<template>
  <div class="other-tag-list">
    <div v-for="item in dialogContentData" :key="item.index" class="member-item">
      <div class="mem-img">
        <img :src="item.avatar || defaultImg" />
      </div>
      <div class="mem-name">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherTagList.vue',
  props: ['dialogContentData'],
  data() {
    return {
      defaultImg: require('@/assets/img/defultPerson1.png')
    };
  }
};
</script>

<style lang="scss" scoped>
.member-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 12px 0;
}
.mem-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}

.mem-name {
  color: $LaleGray8;
  font-size: 18px;
}
</style>
